module.exports = __webpack_public_path__ + "assets/img/rank3.4041ce52.png";